import { render, staticRenderFns } from "./create-ordermanagement.vue?vue&type=template&id=227f663a&"
import script from "./create-ordermanagement.vue?vue&type=script&lang=ts&"
export * from "./create-ordermanagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-ordermanagement.vue"
export default component.exports